export const QUERY_KEY_ADMIN_ALL_ROLES_LIST = 'admin_all_roles_list' as const;
export const QUERY_KEY_ADMIN_APP_CLIENTS_LIST = 'admin_app_clients_list' as const;
export const QUERY_KEY_ADMIN_REVIEW_ITEMS = 'admin_review_items' as const;
export const QUERY_KEY_ADMIN_REVIEW_ITEM_DETAIL = 'admin_review_item_detail' as const;
export const QUERY_KEY_ADMIN_USERS_LIST = 'admin_users_list' as const;
export const QUERY_KEY_AI_FEEDBACK = 'ai_feedback' as const;
export const QUERY_KEY_AI_CHART_REVIEW_SUMMARY = 'ai_chart_review_summary' as const;
export const QUERY_KEY_AI_SEARCH = 'ai_search' as const;
export const QUERY_KEY_AI_EXTRACTION_JOBS = 'ai_extraction_jobs' as const;
export const QUERY_KEY_ALLERGY_HISTORY = 'allergy_history' as const;
export const QUERY_KEY_ATLAS_CONFIG = 'atlas_config' as const;
export const QUERY_KEY_ATLAS_CONFIGS = 'atlas_configs' as const;
export const QUERY_KEY_ATLAS_FACET_GROUPS = 'atlas_facet_groups' as const;
export const QUERY_KEY_ATLAS_FACETS = 'atlas_facets' as const;
export const QUERY_KEY_ACCESSIBLE_BUILDERS = 'accessible_builders' as const;
export const QUERY_KEY_AUTHENTICATED_USER_BY_ID = 'authenticated_user_by_id' as const;
export const QUERY_KEY_BINARY = 'binary' as const;
export const QUERY_KEY_BINARIES_BY_ID = 'binaries_by_id' as const;
export const QUERY_KEY_BINARY_ID = 'patient_binary_id' as const;
export const QUERY_KEY_BUILDER_CONFIG = 'builder_config' as const;
export const QUERY_KEY_CARETEAM = 'patient_care_team' as const;
export const QUERY_KEY_CCDA_PATIENT = 'ccda_patient' as const;
export const QUERY_KEY_CONDITION_HISTORY = 'condition_history' as const;
export const QUERY_KEY_CURRENT_USER_ROLE = 'current_user_role' as const;
export const QUERY_KEY_DOCUMENT_REFERENCE_FOR_BINARY_ID =
  'patient_document_reference_for_binary_id' as const;
export const QUERY_KEY_EHR_BACKFILL_REQUEST = 'ehr_backfill_request' as const;
export const QUERY_KEY_HOTLOAD_STATUS = 'hotload_status' as const;
export const QUERY_KEY_MATCHED_PATIENTS = 'matched_patients' as const;
export const QUERY_KEY_MEDICATION_HISTORY = 'medication_history' as const;
export const QUERY_KEY_NON_THIRD_PARTY_PATIENTS_BY_UPID =
  'non_third_party_patients_by_upid' as const;
export const QUERY_KEY_ON_DEMAND_LENS_API = 'on_demand_lens_api' as const;
export const QUERY_KEY_PATIENT = 'patient' as const;
export const QUERY_KEY_PATIENT_ALLERGIES = 'patient_allergies' as const;
export const QUERY_KEY_PATIENT_APPOINTMENTS = 'patient_appointments' as const;
export const QUERY_KEY_PATIENT_BUILDER_CONDITIONS = 'patient_builder_conditions' as const;
export const QUERY_KEY_PATIENT_COVERAGES = 'patient_coverages' as const;
export const QUERY_KEY_PATIENT_ZUS_RECORDS_COVERAGE = 'patient_zus_records_coverage' as const;
export const QUERY_KEY_PATIENT_BUILDER_ENCOUNTERS = 'patient_builder_encounters' as const;
export const QUERY_KEY_PATIENT_BUILDER_MEDICATIONS = 'patient_builder_medications' as const;
export const QUERY_KEY_PATIENT_DIAGNOSTIC_REPORTS = 'patient_diagnostic_reports' as const;
export const QUERY_KEY_PATIENT_DIAGNOSTIC_REPORTS_PAGE = 'patient_diagnostic_reports_page' as const;
export const QUERY_KEY_PATIENT_DIAGNOSTIC_REPORTS_OVERVIEW =
  'patient_diagnostic_reports_overview' as const;
export const QUERY_KEY_PATIENT_DOCUMENTS = 'patient_documents' as const;
export const QUERY_KEY_PATIENT_DOCUMENTS_WITH_BASICS = 'patient_documents_with_basics' as const;
export const QUERY_KEY_PATIENT_DOCUMENTS_LIST = 'patient_documents_list' as const;
export const QUERY_KEY_DOCUMENT_REFERENCES_FOR_BINARY_IDS =
  'document_references_for_binary_ids' as const;
export const QUERY_KEY_PARENT_DOCUMENTS = 'parent_documents' as const;
export const QUERY_KEY_PATIENT_EPISODES_OF_CARE = 'patient_episodes_of_care' as const;
export const QUERY_KEY_PATIENT_EPISODES_OF_CARE_OVERVIEW =
  'patient_episodes_of_care_overview' as const;
export const QUERY_KEY_PATIENT_HISTORY_DETAILS = 'patient_history_details' as const;
export const QUERY_KEY_PATIENT_HISTORY_LIST = 'patient_history_list' as const;
export const QUERY_KEY_PATIENT_IMMUNIZATIONS = 'patient_immunizations' as const;
export const QUERY_KEY_PATIENT_OBSERVATIONS = 'patient_observations' as const;
export const QUERY_KEY_PATIENT_RESOURCES_BY_TYPES_AND_IDS =
  'patient_resources_by_types_and_ids' as const;
export const QUERY_KEY_PATIENT_RISK_GAPS = 'patient_risk_gaps' as const;
export const QUERY_KEY_PATIENT_RISK_GAPS_INDICATOR = 'patient_risk_gaps_indicator' as const;
export const QUERY_KEY_PATIENT_SEARCH = 'patient_search' as const;
export const QUERY_KEY_PATIENT_SUBSCRIPTION = 'patient_subscription' as const;
export const QUERY_KEY_PATIENT_SUMMARY_CONDITIONS = 'patient_summary_conditions' as const;
export const QUERY_KEY_PATIENT_SUMMARY_ENCOUNTERS = 'patient_summary_encounters' as const;
export const QUERY_KEY_PATIENT_SERVICE_REQUESTS = 'patient_service_requests' as const;
export const QUERY_KEY_PATIENT_SUMMARY_MEDICATIONS = 'patient_summary_medications' as const;
export const QUERY_KEY_PATIENT_SUMMARY_JOB_POLL = 'patient_summary_job_poll' as const;
export const QUERY_KEY_PATIENT_VITALS = 'patient_vitals' as const;
export const QUERY_KEY_PATIENTS_LIST_FQS = 'patients_list_fqs' as const;
export const QUERY_KEY_PRACTITIONER_BY_ID = 'practitioner_by_id' as const;
export const QUERY_KEY_RESOURCE_SEARCH = 'resource_search' as const;
export const QUERY_KEY_TOCS_LIST = 'tocs-list' as const;
export const QUERY_KEY_UPID_PATIENT = 'upid_patient' as const;
